import React from 'react';
import Style from '../Styles/PaymentMethodsComponentStyle';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';

export default function DeliveryMethodsComponent(props) {
  const classes = Style();
    const setDeliveryMethod = (e) => {
        componentMethods.setManagerState({deliveryMethod: e.target.value})
    }
    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

  return (
    <Grid container spacing={3}>
        <Grid item xs={12} lg={12} md={112}>
            <FormControl component="fieldset" style={classes.formControl}>
            <RadioGroup aria-label="deliveryMethod" name="deliveryMethod" value={componentMethods.getManagerState().deliveryMethod} onChange={setDeliveryMethod}>
            {
                componentMethods.getManagerState().deliveryMethods.map((el, idx) => {
                    return <FormControlLabel key={idx} value={el.deliveryMethodsID} control={<Radio color="secondary" />} label={componentConstants.language[el.deliveryMethodsName] +  ' +' + (parseInt(el.deliveryMethodsPrice)/100).toFixed(2) + componentConstants.language.LANG_CURRENCY} />
                })
            }
            </RadioGroup>
            </FormControl>
        </Grid>
    </Grid>
  );
}